import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function ProviderEditStatusDialogHeader({ id }) {
  // Customers Redux state
  const { provider, actionsLoading } = useSelector(
    (state) => ({
      provider: state.providers.provider,
      actionsLoading: state.providers.actionsLoading,
    }),
    shallowEqual
  );

  const [title, setTitle] = useState("");
  // Title couting
  useEffect(() => {
    let _title = id ? "" : "New Provider";
    if (provider && id) {
      _title = `Edit status for: ${provider?.title} ${provider?.user?.first_name}  ${provider?.user?.last_name}`;
    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [provider, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
    </>
  );
}
